import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { AppServices } from 'middleware'
import { createQueryResponseHandling } from 'utils/errorHandler'
import { TimeSlotGroup } from './timeSlotsService'

const tenMinutes = 10 * 60

export const timeSlotsApi = createApi({
    reducerPath: 'timeSlotsApi',
    tagTypes: ['TimeSlotGroups', 'TimeSlotGroup'],
    baseQuery: fetchBaseQuery({}),
    endpoints: () => ({}),
})

export interface TimeSlotGroupsResult {
    groups: TimeSlotGroup[]
    slotsIncluded: boolean
}

const extendedApi = timeSlotsApi.injectEndpoints({
    endpoints: (builder) => ({
        getTimeSlotGroups: builder.query<TimeSlotGroupsResult, string>({
            providesTags: (_, __, accountSlug) => [{ type: 'TimeSlotGroups', id: accountSlug }, 'TimeSlotGroups'],
            keepUnusedDataFor: tenMinutes,
            queryFn: (accountSlug) =>
                createQueryResponseHandling(async () => {
                    const groups = await AppServices.timeSlotsService.listAllTimeSlotGroups(accountSlug)
                    const slotsIncluded = groups.length > 0 && groups.every((group) => Array.isArray(group.timeSlots))
                    return { groups, slotsIncluded }
                }),
        }),
        getTimeSlotGroup: builder.query<TimeSlotGroup, { accountSlug: string; groupId: string }>({
            providesTags: (_, __, { groupId }) => [{ type: 'TimeSlotGroup', id: groupId }],
            keepUnusedDataFor: tenMinutes,
            queryFn: ({ accountSlug, groupId }) =>
                createQueryResponseHandling(() => AppServices.timeSlotsService.getTimeSlot(accountSlug, groupId)),
        }),
    }),
})

export const { reducer, reducerPath } = timeSlotsApi
export const { useGetTimeSlotGroupsQuery, useGetTimeSlotGroupQuery, useLazyGetTimeSlotGroupQuery } = extendedApi
